import { ToDateTimeText } from "../../../utils/date";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Box from "@material-ui/core/Box";

export const getColumns = (editRow, deleteRow) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editRow(row);
              }}
            />
            <DeleteIcon
              color="action"
              onClick={() => {
                deleteRow(row.USER_ID);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "USER_ID",
      text: "User ID",
      sort: true,
      headerAlign: "center",
    },
    {
      dataField: "PERMISSION",
      text: "Permission",
      sort: true,
      headerAlign: "center",
      align: "Left",
    },
    {
      dataField: "UPDATE_DATE",
      text: "Last Update Time",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.UPDATE_DATE)}</>;
      },
    },
    {
      dataField: "UPDATE_BY",
      text: "Update By",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
  ];
  return columns;
};
export const getHistoryColumns = () => {
  const columns = [
    {
      dataField: "ACTION",
      text: "Action",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "150px", textAlign: "center" };
      },
      align: "center",
    },
    {
      dataField: "MESSAGE",
      text: "Item",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "300px", textAlign: "center" };
      },
      align: "left",
    },
    {
      dataField: "REMARK",
      text: "Remark",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "300px", textAlign: "center" };
      },
      align: "left",
    },
    {
      dataField: "UPDATE_BY",
      text: "Update By",
      sort: false,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "UPDATE_DATE",
      text: "Update Date",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.UPDATE_DATE)}</>;
      },
    },
  ];
  return columns;
};
export const getPermissionColumns = () => {
  const columns = [
    {
      dataField: "TEMPLATE_NAME",
      text: "Template",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "800px" };
      },
      align: "left",
    },
  ];
  return columns;
};
